var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3035_7609",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3035_7609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0208 13.3118C12.8958 13.173 12.8333 13.0202 12.8333 12.8535C12.8333 12.6868 12.8958 12.541 13.0208 12.416L14.6042 10.8327H8.22917C8.04861 10.8327 7.89945 10.7735 7.78167 10.6552C7.66333 10.5374 7.60417 10.3882 7.60417 10.2077C7.60417 10.0271 7.66333 9.87768 7.78167 9.75935C7.89945 9.64157 8.04861 9.58268 8.22917 9.58268H14.6042L13.0208 7.97852C12.8958 7.85352 12.8333 7.70768 12.8333 7.54102C12.8333 7.37435 12.8958 7.22852 13.0208 7.10352C13.1458 6.97852 13.2917 6.91602 13.4583 6.91602C13.625 6.91602 13.7639 6.97157 13.875 7.08268L16.4792 9.68685C16.5486 9.75629 16.6008 9.83602 16.6358 9.92602C16.6703 10.0166 16.6875 10.1105 16.6875 10.2077C16.6875 10.3049 16.6703 10.3985 16.6358 10.4885C16.6008 10.5791 16.5486 10.6591 16.4792 10.7285L13.875 13.3327C13.75 13.4716 13.6078 13.5341 13.4483 13.5202C13.2883 13.5063 13.1458 13.4368 13.0208 13.3118ZM4.5 17.4993C4.08333 17.4993 3.72917 17.3535 3.4375 17.0618C3.14583 16.7702 3 16.416 3 15.9993V4.41602C3 3.99935 3.14583 3.64518 3.4375 3.35352C3.72917 3.06185 4.08333 2.91602 4.5 2.91602H9.47917C9.64583 2.91602 9.79167 2.9749 9.91667 3.09268C10.0417 3.21102 10.1042 3.36046 10.1042 3.54102C10.1042 3.72157 10.0417 3.87074 9.91667 3.98852C9.79167 4.10685 9.64583 4.16602 9.47917 4.16602H4.5C4.44444 4.16602 4.38889 4.19379 4.33333 4.24935C4.27778 4.3049 4.25 4.36046 4.25 4.41602V15.9993C4.25 16.0549 4.27778 16.1105 4.33333 16.166C4.38889 16.2216 4.44444 16.2493 4.5 16.2493H9.47917C9.64583 16.2493 9.79167 16.3082 9.91667 16.426C10.0417 16.5443 10.1042 16.6938 10.1042 16.8743C10.1042 17.0549 10.0417 17.2043 9.91667 17.3227C9.79167 17.4405 9.64583 17.4993 9.47917 17.4993H4.5Z",
    fill: "#366EE3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.d6b2ba84209f060a8b79c1d23897890d.svg";
export { ForwardRef as ReactComponent };